import { useRouteMatch } from 'react-router-dom';

export const usePreview = () => {
  return !!useRouteMatch('/preview');
};
